// Reel frame themes — mirrors pipeline/reels/frame_themes.py. Keep the ids
// identical across both so the UI can pass a theme id straight to
// story_reels.frame_theme, which pipeline/reels/job_worker.py reads.
//
// Unlike POSTER_THEMES (a color palette fed into an image-gen prompt), each
// entry here points at an actual ornate-frame PNG asset — there's only one
// real theme today (the frame this session's reel layout was designed
// against). This is the picker infrastructure; new frame artwork is a
// separate task.

export const REEL_FRAME_THEMES = [
  {
    id: "ornate-gold",
    name: "Ornate Gold — Classical Kathakala",
    tagline: "The current frame — gold border, navy card",
    swatch: "#C9A84C",
  },
];

export const DEFAULT_REEL_FRAME_THEME_ID = "ornate-gold";

export function getReelFrameTheme(id) {
  return REEL_FRAME_THEMES.find((t) => t.id === id) || null;
}
